import Vue from "vue";
import VueRouter from "vue-router";

import Login from "../views/Login.vue";
import Environnement from "@/views/Environnement";
import Fiche from "../views/Fiche.vue";
import Assignation from "@/views/Assignation";
import Moderation from "@/views/Moderation";
import Detail from "@/views/Detail/Detail";
import Visio from "@/views/View";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        redirect: "login"
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            header: "S'identifier",
            title: "OdP - Authentification"
        }
    },
    {
        path: "/envs",
        name: "envs",
        component: Environnement,
        meta: {
            header: "Choix de l'environnement",
            title: "OdP - Environnement"
        }
    },
    {
        path: "/assign",
        name: "assign",
        component: Assignation,
        meta: {
            header: "Liste des demandes",
            title: "OdP - Page principale"
        }
    },
    {
        path: "/moder",
        name: "moder",
        component: Moderation,
        meta: {
            header: "Liste des demandes",
            title: "OdP - Page principale"
        }
    },
    {
        path: "/assign/fiche/:layername/:id",
        name: "ficheAssign",
        component: Fiche,
        meta: {
            requiresAuth: false,
            title: "OdP - Détail",
            header: "Détail de l'OdP"
        }
    },
    {
        path: "/moder/fiche/:layername/:id",
        name: "ficheModer",
        component: Fiche,
        meta: {
            requiresAuth: false,
            title: "OdP - Détail",
            header: "Détail de l'OdP"
        }
    },
    {
        path: "/detail/:unique_id",
        name: "detail",
        component: Detail,
        meta: {
            requiresAuth: false,
            title: "Occupation du Domaine Public - Détail",
            header: "Détail de l'OdP"
        }
    },
    {
        path: "/visio",
        name: "view",
        component: Visio
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router;